import { render, staticRenderFns } from "./IconClock.vue?vue&type=template&id=05b0a004&scoped=true"
import script from "./IconClock.vue?vue&type=script&lang=js"
export * from "./IconClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b0a004",
  null
  
)

export default component.exports